import { render, staticRenderFns } from "./DropCourseRecord.vue?vue&type=template&id=08a17cee"
import script from "./DropCourseRecord.vue?vue&type=script&lang=ts"
export * from "./DropCourseRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports